import { useEffect } from "react";
import { TextToSpeech } from "./Text-To-Speech";

export const WysiwygDisplay = ({ data, className, enableAudio = true }) => {
    const sanitize = () => {
        if (!data) return data;
        let content = data;
        content = content.replace(/<p><iframe/g, `<p class="VideoEmbed"><iframe allow="autoplay" `);
        // Add controlsList="nodownload" to video tags
        content = content.replace(/<video/g, `<video controls controlsList="nodownload"`);
        return content;
    };
    const content = sanitize();

    useEffect(() => {
        const handleContextMenu = (event) => {
            event.preventDefault();
        };

        document.addEventListener("contextmenu", handleContextMenu);

        return () => {
            document.removeEventListener("contextmenu", handleContextMenu);
        };
    }, []);

    return (
        <>
            {enableAudio && <TextToSpeech text={content} />}
            <div className={className} dangerouslySetInnerHTML={{ __html: content }} />
        </>
    );
};
